import { useDebouncedSearch } from "@/hooks/useDebouncedSearch";
import { Input } from "..";

type SearchInputProps = {
  placeholder?: string;
  delay?: number;
  onSearch: (value: string) => void;
};

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = "Search",
  delay,
  onSearch,
}) => {
  const { inputValue, onChange, isPending } = useDebouncedSearch({
    delay,
    onSearch, // ⬅️ this is your API caller now
  });

  return (
    <div className="relative w-full">
      <Input
        type="search"
        placeholder={placeholder}
        value={inputValue}
        onChange={onChange}
      />
      {isPending && (
        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
          Searching...
        </span>
      )}
    </div>
  );
};

export default SearchInput;
